import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/coaches/cco/")({
  beforeLoad: () => {
    throw redirect({
      to: "/organizations",
      statusCode: 301,
      throw: true,
    });
  },
  component: () => null,
  staticData: { title: "Coaching Certification Organizations" },
});
